export const loadingIndicatorDelay = 300
